import { render } from "./Favourites.vue?vue&type=template&id=5d09dda4"
import script from "./Favourites.vue?vue&type=script&lang=js"
export * from "./Favourites.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/autoclick_production_volume/websites/production/INCOMPLETE_dea1e908be77e1b0985a293b718d0cc9134e92ed/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__